import React from 'react';
import { motion } from 'framer-motion';
import { HelpCircleIcon, SparklesIcon } from 'lucide-react';
import { aiQuestions, painPoints } from '../data/painPoints';
export function PainPoints() {
  return <section aria-labelledby="pain-title" className="bg-canvas" data-id="element-157" data-mp="26z7muryed7ce">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:py-20" style={{
      paddingTop: "22px"
    }} data-id="element-158" data-mp="2bxiwb1ks5fu3">
        <div className="grid gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16" data-id="element-159" data-mp="2bv69ob42uhap">
          <div data-id="element-160" data-mp="1xwg9unpvi3in">
            <p className="text-sm font-semibold text-cyan-ink" data-id="element-161" data-mp="1y042lknhulwb">Does this sound like you?</p>
            <h2 id="pain-title" className="mt-2 font-display text-3xl font-black leading-tight text-ink sm:text-4xl" data-id="element-162" data-mp="21x8jhi2nqafg">
              AI can do more for your real estate business.
            </h2>
            <p className="mt-5 text-base leading-relaxed text-muted" data-id="element-163" data-mp="1t0r6e9aqg2h2">
              You know AI can help your real estate business… but every time you open ChatGPT, you still have to figure out:
            </p>
            <ul className="mt-5 space-y-3" data-id="element-164" data-mp="3nablq5q3ls6z">
              {aiQuestions.map(q => <li key={q} className="flex items-start gap-3 text-[15px] font-medium text-ink" data-id="element-165" data-mp="1yz3w4w4800fs">
                  <HelpCircleIcon className="mt-0.5 h-4 w-4 shrink-0 text-cyan" aria-hidden="true" data-id="element-166" data-mp="1u12e8eij675w" />
                  {q}
                </li>)}
            </ul>
            <div className="mt-8 border-l-2 border-gold pl-4" data-id="element-167" data-mp="23qveijd82zuu">
              <p className="text-base text-muted" data-id="element-168" data-mp="23thv18i3cpp7">You don’t need more AI theory.</p>
              <p className="font-display text-lg font-extrabold text-ink" data-id="element-169" data-mp="1g22r5bao20bu">You need a strategic framework.</p>
            </div>
          </div>

          <div className="grid gap-4 sm:grid-cols-2" data-id="element-170" data-mp="1p291wpezcm7b">
            {painPoints.map((p, i) => <motion.div key={p.title} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-40px'
          }} transition={{
            duration: 0.25,
            delay: i * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col rounded-2xl border border-line bg-white p-6" data-id="element-171" data-mp="1p04ongv6yaud" data-mpi={i}>
                <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-cyan-soft" data-id="element-172" data-mp="1t7hpye37su5u">
                  <p.icon className="h-[18px] w-[18px] text-cyan-ink" aria-hidden="true" data-id="element-173" data-mp="1y62rcgu7djvv" />
                </span>
                <h3 className="mt-4 font-display text-base font-extrabold text-ink" data-id="element-174" data-mp="274xv7m9ryhw0">{p.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-muted" data-id="element-175" data-mp="1aenngjms2uii">{p.desc}</p>
              </motion.div>)}
          </div>
        </div>

        <p className="mt-14 flex items-center justify-center gap-2 text-center font-display text-xl font-extrabold text-ink sm:text-2xl" data-id="element-176" data-mp="1ehafolnd2hg8">
          <SparklesIcon className="h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-177" data-mp="1jd91q2l7vndh" />
          If you answered YES, SIGMA SMART™ has the solution.
        </p>
      </div>
    </section>;
}